var map = {
	"./2.jpeg": 6113,
	"./IMG_0763.JPG": 2905,
	"./IMG_0767.JPG": 2885,
	"./IMG_0768.JPG": 7894,
	"./IMG_9272.JPG": 9949,
	"./IMG_9349.JPG": 4330,
	"./IMG_9559.JPG": 1335,
	"./IMG_9688.JPG": 9586,
	"./IMG_9844.JPG": 4660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1987;